import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnChanges {
  @Input('value') value = 0.0;
  @Input('showText') showText = true;

  constructor() { }

  ngOnInit() {}

  ngOnChanges(old: SimpleChanges) {
    if (this.value > 100) {
      this.value = 100;
    }
  }
}
